/**
 * Stable CSS class names for E2E — ServiceManagment page.
 */
export const SM = {
    page: 'service-managment-page',
    title: 'service-managment-page__title',
    cardsStack: 'service-managment-page__cards-stack',
    omniChannelSection: 'service-managment-page__omni-channel-section',
    operationFlagSection: 'service-managment-page__operation-flag-section',
    orderActionRulesSection: 'service-managment-page__order-action-rules-section',
} as const;

export const smCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

